export enum StaleTime {
    Short = 60_000, // 1 minute
    Medium = 150_000, // 2.5 minutes
    Long = 300_000, // 5 minutes
    Hour = 3_600_000, // 1 hour
}
